import { PartnerRecord } from 'tenants/registry';
import { getCurrentTenant, getPartner } from 'tenants/utils';

export type CurrentPartnerType = () => PartnerRecord;

export const useCurrentPartner: CurrentPartnerType = () => {
	const tenant = getCurrentTenant() || '';
	return getPartner(tenant, 'lotsa');
};
